const r = (t) => new TextEncoder().encode(t), n = {};
for (let t = 0; t < 256; t++) {
  let e = t.toString(16).toLowerCase();
  e.length === 1 && (e = `0${e}`), n[t] = e;
}
function f(t) {
  let e = "";
  for (let o = 0; o < t.byteLength; o++)
    e += n[t[o]];
  return e;
}
export {
  r as f,
  f as t
};
